function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M87.06,110.08h0l-.72.29c-5,2.09-8.21,5.24-8.21,8.5,0,3.63,3.93,7.13,10,9.17a14.26,14.26,0,0,1-1.07-18Z"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 100,
  cy: 118.39,
  rx: 9.37,
  ry: 8.91
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M112.94,110.08l.28.4a14.24,14.24,0,0,1,2.4,7.91,14.39,14.39,0,0,1-3.76,9.66c6.08-2.05,10-5.55,10-9.18C121.87,115.46,118.39,112.16,112.94,110.08Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M186.54,54.73a8,8,0,0,0-4-6.93L103.93,2.42a8,8,0,0,0-8,0L17.4,47.69a8,8,0,0,0-4,6.94l.06,90.64a8,8,0,0,0,4,6.93l78.61,45.38a8,8,0,0,0,8,0l78.54-45.27a8,8,0,0,0,4-6.94Zm-30.65,47.51c0,18.79-11.73,35.8-29.85,43.35L100,156.5,74,145.59C55.84,138,44.14,121,44.11,102.24V65.68a10.15,10.15,0,0,1,9.39-9.9L61.9,55A40.57,40.57,0,0,0,83.21,46.4l6.42-5.1a16.82,16.82,0,0,1,20.74,0h0l6.42,5.1A40.57,40.57,0,0,0,138.1,55l8.4.82a10.15,10.15,0,0,1,9.39,9.9Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M145.51,64.84l-8.4-.82a50.45,50.45,0,0,1-26.47-10.64l-6.42-5.1a6.85,6.85,0,0,0-8.44,0l-6.42,5.1A50.45,50.45,0,0,1,62.89,64l-8.4.82a.86.86,0,0,0-.8.84v36.56c0,15.19,9.49,28.93,24.13,35L100,146.55l22.18-9.29c14.64-6.09,24.1-19.83,24.13-35V65.68A.86.86,0,0,0,145.51,64.84Zm-32.57-3.18h6.51V94.22h-6.51Zm-22,0h7.66l10.47,32.56h-6.82L100,85.86H89.44l-2.29,8.36h-6.6Zm9,74.16c-15.3,0-28.12-7.17-28.12-16.95s12.82-17,28.12-17,28.12,7.17,28.12,17S115.3,135.82,100,135.82Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M97.63,77.24c-1-3.39-1.9-7.13-2.86-10.65h-.18c-.84,3.56-1.8,7.26-2.77,10.65l-1,3.56h7.74Z"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u76D1\u7BA1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.17fbcb38.svg";
export { ForwardRef as ReactComponent };